import { hexToResource } from "../hexToResource";

/** @deprecated use `hexToResource` instead */
export const hexToResourceId = hexToResource;
